/* CVF-054-DI */
(function () {
  var HEADER_OFFSET = 180;

  function markVehicleTarget() {
    var mount = document.getElementById('cm-ymm');
    if (!mount) return null;

    var section = mount.closest('.shopify-section') || mount.parentElement;
    if (!section) return mount;

    var anchor = section.querySelector('.cvf-054-ab-vehicle-anchor');
    if (!anchor) {
      anchor = document.createElement('div');
      anchor.id = 'shop-by-vehicle';
      anchor.className = 'cvf-054-ab-vehicle-anchor';
      section.insertBefore(anchor, section.firstChild);
    }

    return mount;
  }

  function scrollToFilters(target) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({
      top: Math.max(0, top),
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
  }

  function init() {
    var root = document.querySelector('.cvf-054-ab-smart-money-hook--var-1');
    if (!root) return;

    markVehicleTarget();

    root.querySelectorAll('[data-cvf054-cta="shop-by-vehicle"]').forEach(function (link) {
      link.setAttribute('href', '#shop-by-vehicle');
      link.addEventListener('click', function (event) {
        var target = markVehicleTarget();
        if (!target) return;
        event.preventDefault();
        if (window.location.hash !== '#shop-by-vehicle') {
          history.pushState(null, '', '#shop-by-vehicle');
        }
        scrollToFilters(target);
      });
    });

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (markVehicleTarget() || tries > 24) window.clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
